function attachTimeline(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}

export { attachTimeline };
